import styled from "styled-components";

export const StyledTabletArticleNavigationWrapper = styled.div``;

export const StyledTabletArticleNavigationTitle = styled.p`
  font-weight: 700;
`;

export const StyledTabletArticleNavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledTabletArticleNavigationItem = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 500;
  color: #86723E;
  font-size: 18px;
  cursor: pointer;
  line-height: 24px;
  letter-spacing: 0.7px;
`;
